import React from 'react';
import HomeTemplate from '../../templates/Home/HomeTemplate';

export default function Home({ name, fatherLastName }) {
  return <HomeTemplate name={`${name} ${fatherLastName}`} />;
}
